import { BagIcon as PhosphorBagIcon } from "@phosphor-icons/react/dist/ssr/Bag";

import { createAppIcon } from "@/components/createAppIcon";

export const ShoppingBagIcon = /* @__PURE__ */ createAppIcon(PhosphorBagIcon);
